export default __webpack_public_path__ + "static/media/warning--descent-or-climbing-lanes-in-triple-lanes--g1.f42d15ba.png";